import { UpdateResponsibleMedicalRecordDTO } from '../models/UpdateMedicalRecordDTO'
import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function ReviewResponsibleMedicalRecordUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: {
    patientId: string
    responsibleMedicalRecordId: string
    data: UpdateResponsibleMedicalRecordDTO
  }) => {
    return await repository.reviewResponsibleMedicalRecord(params)
  }
}
